import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Logo } from '@/components/brand/logo'
import { NAV_LINKS, siteConfig } from '@/constants/site'

const COMPANY_LINKS = [
    { href: '/#contact', label: 'Get a quote' },
    { href: '/brand', label: 'Brand assets' }
]

const linkClass = 'text-paper/70 transition-colors hover:text-volt focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-volt rounded-sm'

const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='border-t border-paper/10 bg-ink text-paper'>
            <div className='mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8'>
                <div className='flex flex-col gap-12 md:flex-row md:items-start md:justify-between'>
                    <div className='max-w-sm'>
                        <Logo variant='full' tone='dark' className='h-14 w-auto' />
                        <p className='mt-6 text-sm leading-relaxed text-paper/60'>
                            Websites for local businesses and big companies, designed and built at prices that make sense.
                        </p>
                    </div>

                    <nav aria-label='Footer' className='grid grid-cols-2 gap-12 text-sm sm:gap-20'>
                        <div>
                            <p className='font-heading text-xs font-semibold uppercase tracking-[0.16em] text-paper/40'>
                                Explore
                            </p>
                            <ul className='mt-4 space-y-3'>
                                {NAV_LINKS.map(item => (
                                    <li key={item.href}>
                                        <Link href={item.href} className={linkClass}>
                                            {item.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div>
                            <p className='font-heading text-xs font-semibold uppercase tracking-[0.16em] text-paper/40'>
                                Company
                            </p>
                            <ul className='mt-4 space-y-3'>
                                {COMPANY_LINKS.map(item => (
                                    <li key={item.href}>
                                        <Link href={item.href} className={linkClass}>
                                            {item.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </nav>
                </div>

                <div className='mt-14 flex flex-col gap-3 border-t border-paper/10 pt-6 text-xs text-paper/45 sm:flex-row sm:items-center sm:justify-between'>
                    <p>
                        © <span suppressHydrationWarning>{new Date().getFullYear()}</span> {siteConfig.name}. All rights reserved.
                    </p>
                    <p>
                        {siteConfig.tagline}
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default SiteFooter
